import { Field } from "react-final-form";

import RatingStar from "@components/Icons/RatingStar";
import { isRequired } from "@lib/validations";

const EditReviewModalRating = ({ values }) => (
  <>
    <label className="mt-6 -mb-4 Form-label is-required">
      Selecteaza o nota
    </label>
    <div className="flex items-center mb-2">
      {[1, 2, 3, 4, 5].map((starVal) => (
        <Field
          key={`star-item-${starVal}`}
          name="rating"
          label={
            <RatingStar
              width="23px"
              height="21px"
              className={`mr-3px cursor-pointer ${
                values && values.rating && values.rating >= starVal
                  ? "text-yellow"
                  : "text-gray-200"
              }`}
            />
          }
          type="radio"
          value={starVal}
          validate={isRequired()}
        >
          {(props) => (
            <label className="Form-radio" style={{ margin: 0, padding: 0 }}>
              <input
                {...props.input}
                type="radio"
                disabled={props.disabled}
                className="checkbox-input opacity-0 w-0 h-0"
              />
              {typeof props.label === "string" ? (
                <span dangerouslySetInnerHTML={{ __html: props.label }}></span>
              ) : (
                props.label
              )}
            </label>
          )}
        </Field>
      ))}
    </div>
  </>
);

export default EditReviewModalRating;
